export var Playability;
(function (Playability) {
    /**
     * Segment is not playable, such as TRM that has not been converted yet or has been archived.
     */
    Playability["NotPlayable"] = "not playable";
    /**
     * Segment is playable, e.g. a past recording.
     */
    Playability["Playable"] = "playable";
    /**
     * Segment is currently streaming live.
     */
    Playability["Live"] = "live";
})(Playability || (Playability = {}));
